<template>
  <b-modal
    hide-footer
    id="modal-ocpb-care-history"
    ref="modal-ocpb-care-history"
    size="lg"
    title="ประวัติการดำเนินงาน OCPB Care"
  >
    <b-overlay :show="isLoading" rounded="sm">
      <b-row v-if="careCode">
        <b-col cols="12" class="text-left m-1">
          <h5 class="mb-0">เลขรับเรื่อง : {{ careCode }}</h5>
          <small class="text-muted" v-if="currentStatus">
            สถานะปัจจุบัน : {{ currentStatus.statusName }}
            <span v-if="currentStatus.departmentName">
              ({{ currentStatus.departmentName }})</span
            >
          </small>
        </b-col>
      </b-row>

      <b-row
        v-for="(tracking, index) in trackings"
        :key="tracking.trackingId"
      >
        <b-col cols="12" class="list-group list-group-circle text-left m-1">
          <div class="d-flex list-group-item">
            <div class="">
              <h5 class="mb-0">
                {{ index + 1 }}. {{ tracking.departmentName }}
              </h5>
            </div>
            <div class="col ml-auto">
              <hr class="my-12 bg-dark" />
            </div>
          </div>

          <div
            v-for="(item, detailIndex) in tracking.details"
            :key="item.trackingDetailId"
            class="d-flex justify-content-round ml-2 mr-5"
          >
            <div class="w-100">
              <div class="d-flex justify-content-between ml-2">
                <span class="mb-0">
                  {{ detailIndex + 1 }} ) {{ item.statusName }}
                </span>
              </div>

              <div class="d-flex justify-content-between ml-2 text-left">
                <small class="mb-0">{{ item.createDateStr }}</small>
              </div>

              <hr class="my-12 bg-dark w-100" />
            </div>
          </div>
        </b-col>
      </b-row>

      <b-row v-if="!isLoading && trackings.length === 0">
        <b-col cols="12" class="text-center m-1">
          <span class="text-muted">ไม่พบประวัติการดำเนินงาน</span>
        </b-col>
      </b-row>
    </b-overlay>
  </b-modal>
</template>

<script>
import { BRow, BCol, BModal, BButton, BOverlay } from "bootstrap-vue";

import * as storeTracking from "@/store/api/tracking/index.js";

export default {
  components: {
    BRow,
    BCol,
    BButton,
    BModal,
    BOverlay,
  },
  data() {
    return {
      careCode: null,
      currentStatus: null,
      trackings: [],
      isLoading: false,
    };
  },
  methods: {
    // เปิด modal พร้อมโหลดประวัติการดำเนินงานจากรหัส เช่น "OCPB0269/00466"
    showByCode(code) {
      this.careCode = code;
      this.currentStatus = null;
      this.trackings = [];
      this.$refs["modal-ocpb-care-history"].show();
      this.loadCareTracking(code);
    },
    loadCareTracking(code) {
      const _this = this;
      _this.isLoading = true;
      storeTracking
        .getCareTrackingForComplaint(code)
        .then((response) => {
          const data = response.data.data;
          if (data) {
            _this.careCode = data.code ? data.code : code;
            _this.currentStatus = data.currentStatus;
            _this.trackings = data.trackings ? data.trackings : [];
          }
          _this.isLoading = false;
        })
        .catch((error) => {
          console.log("error", error);
          _this.currentStatus = null;
          _this.trackings = [];
          _this.isLoading = false;
        });
    },
  },
};
</script>

<style></style>
